import React from 'react'
import { Helmet } from 'react-helmet'
import { LazyLoadImage } from 'react-lazy-load-image-component'

export default function About() {
  return (
        <>



<div className="container">
            <div className="container-fluid ">
            
    <div className="row align-items-center ">
      <div className="col-md-6 col-12 col-sm-6">
        <div className="about-img-div">
        <LazyLoadImage src="/images/home/hotel_img.jpg" loading='lazy' className="img-fluid1 rounded" alt="V Hotel The Grnad Shoba front view" title='Welcome to V Hotel
      The Grand Shoba'/>
        </div>
      </div>
      <div className="col-md-6 col-sm-6 col-12 about-description" id='about'>
        <h1>Best Hotel Near Delhi Airport  </h1>
       
        <p>
        Located just minutes from Indira Gandhi International Airport near Terminals 2 and 3, V Hotel The Grand Shoba in Mahipalpur and Vasant Kunj offers ideal convenience for international, domestic, and connecting flight travelers. 
          </p>
          <p>Our luxury hotel features 100 elegant rooms and suites with modern amenities, perfect for business and leisure stays.  <br />
Dine at our signature restaurants—Safar, Zaika, Aerostag, and Udaan—serving global and Indian cuisine curated by expert chefs. 

</p>
<p>
</p>
<p>
  Host unforgettable weddings, meetings, or events in our banquet and conference halls near IGI Airport. 
  Relax by the infinity pool or unwind at our wellness club. With exceptional service and comfort, your stay is designed to be both memorable and seamless.
</p>

      </div>
    </div>
  </div>

    
            </div>
        </>
  )
}
